
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Home from "./components/Home.js";
import Privacy from "./components/Privacy.js";

function App(){
    return (
        <BrowserRouter>
            {/* NavigationGuard removed */}
            <Routes>
                <Route path="/" element={<Home />}/>
                <Route path="/privacy" element={<Privacy />}/>
            </Routes>
        </BrowserRouter>);
  }


export default App;

